import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquareMinus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import EditModal from "../ui/EditModal";

const AddDiagnosticoPorPatologia = () => {
  const [editandoRelacion, setEditandoRelacion] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [DiagnosticosPorPatologia, setDiagnosticosPorPatologia] = useState([]);
  const [Patologias, setPatologias] = useState([]);
  const [IdPatologia, setIdPatologia] = useState("");
  const [Diagnosticos, setDiagnosticos] = useState([]);
  const [IdDiagnostico, setIdDiagnostico] = useState("");

  useEffect(() => {
    getPatologias();
    getDiagnosticos();
  }, []);

  useEffect(() => {
    setIdDiagnostico("");
    getDiagnosticosPorPatologia();
  }, [IdPatologia]);

  const getPatologias = async () => {
    try {
      const response = await api.get(`/patologias`);
      const activas = response.data.filter((p) => p.estado === 1);
      setPatologias(activas);
    } catch (error) {
      console.error("Error al obtener patologias:", error);
      Swal.fire("Error", "No se pudieron cargar las patologias", "error");
    }
  };

  const getDiagnosticos = async () => {
    try {
      const response = await api.get(`/diagnosticos`);
      const activos = response.data.filter((a) => a.Estado === 1);
      setDiagnosticos(activos);
    } catch (error) {
      console.error("Error al obtener diagnosticos:", error);
    }
  };

  const getDiagnosticosPorPatologia = async () => {
    if (!IdPatologia) return;
    try {
      const response = await api.get(`/diagnosticosPorPatologia/${IdPatologia}`);
      setDiagnosticosPorPatologia(response.data);
    } catch (error) {
      console.error("Error al obtener diagnosticos por patologia:", error);
    }
  };

  const createDiagnosticoPorPatologia = async (e) => {
    e.preventDefault();

    if (!IdPatologia || !IdDiagnostico) {
      return Swal.fire("Campos incompletos", "Debe seleccionar una patologia y un diagnostico.", "warning");
    }

    const yaExiste = DiagnosticosPorPatologia.some((item) => item.IdDiagnostico === IdDiagnostico);
    if (yaExiste) {
      return Swal.fire("Duplicado", "Este diagnostico ya esta asociado a la patologia.", "error");
    }

    try {
      await api.post(`/diagnosticosPorPatologia`, {
        IdPatologia,
        IdDiagnostico,
      });
      Swal.fire("Exito", "El diagnostico se asocio correctamente a la patologia.", "success");
      getDiagnosticosPorPatologia();
      setIdDiagnostico("");
    } catch (error) {
      console.error("Error al guardar:", error);
      Swal.fire("Error", "Ocurrio un error al guardar. Intente nuevamente.", "error");
    }
  };

  const cambiarEstado = async (id) => {
    try {
      const response = await api.patch(`/diagnosticosPorPatologia/toggle/${id}`);
      const nuevoEstado = response.data.estado === 1 ? "activado" : "desactivado";
      Swal.fire("Actualizado", `El diagnostico ha sido ${nuevoEstado} correctamente`, "success");
      getDiagnosticosPorPatologia();
    } catch (error) {
      console.error("Error al cambiar estado:", error);
      Swal.fire("Error", "No se pudo cambiar el estado", "error");
    }
  };

  const handleEditar = async (valores) => {
    try {
      await api.put(`/diagnosticos/${valores.IdDiagnostico}`, {
        Nombre: valores.Nombre,
        Descripcion: valores.Descripcion || "",
      });
      Swal.fire("Actualizado", "El diagnostico ha sido editado correctamente", "success");
      setEditandoRelacion(null);
      getDiagnosticosPorPatologia();
      getDiagnosticos();
    } catch (error) {
      console.error("Error al editar:", error.response?.data || error.message);
      Swal.fire("Error", "No se pudo actualizar el diagnostico", "error");
    }
  };

  const editFields = [
    {
      name: "Nombre",
      label: "Nombre",
      type: "text",
      required: true,
    },
    {
      name: "Descripcion",
      label: "Descripcion",
      type: "textarea",
      required: false,
    },
  ];

  const filtrarPorEstado = () => {
    if (filtroEstado === "todas") return DiagnosticosPorPatologia;
    if (filtroEstado === "activas") return DiagnosticosPorPatologia.filter((a) => a.estado === 1);
    if (filtroEstado === "inactivas") return DiagnosticosPorPatologia.filter((a) => a.estado === 0);
    return DiagnosticosPorPatologia;
  };

  useEffect(() => {
    let mensaje = "";
    switch (filtroEstado) {
      case "activas":
        mensaje = "Mostrando relaciones activas.";
        break;
      case "inactivas":
        mensaje = "Mostrando relaciones inactivas.";
        break;
      case "todas":
        mensaje = "Mostrando todas las relaciones.";
        break;
      default:
        break;
    }

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "info",
      title: mensaje,
      showConfirmButton: false,
      timer: 1800,
      timerProgressBar: true,
    });
  }, [filtroEstado]);

  const columnas = [
    {
      name: "Diagnostico",
      selector: (row) => row?.NombreDiagnostico || "No disponible",
      sortable: true,
    },
    {
      name: "Acciones",
      cell: (row) => (
        <>
          <button
            className="button is-small is-info mr-2"
            type="button"
            title="Editar"
            onClick={() => setEditandoRelacion({
              IdDiagnostico: row.IdDiagnostico,
              Nombre: row.NombreDiagnostico,
              Descripcion: row.Descripcion || "",
            })}
          >
            <FontAwesomeIcon icon={faPencil} />
          </button>

          {row.estado === 1 ? (
            <FontAwesomeIcon
              icon={faSquarePlus}
              style={{ color: "#37ff00", cursor: "pointer", marginLeft: "10px" }}
              size="2xl"
              title="Activar"
              onClick={() => cambiarEstado(row.IdDiagnosticoPorPatologia)}
            />
          ) : (
            <FontAwesomeIcon
              icon={faSquareMinus}
              style={{ color: "#ff0000", cursor: "pointer", marginLeft: "10px" }}
              size="2xl"
              title="Desactivar"
              onClick={() => cambiarEstado(row.IdDiagnosticoPorPatologia)}
            />
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
  ];

  const paginationOptionsES = {
    rowsPerPageText: "Filas por pagina",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Diagnosticos por Patologia</strong>
        </div>

        <form onSubmit={createDiagnosticoPorPatologia}>
          <div className="field">
            <label className="label required">Seleccionar Patologia</label>
            <div className="select is-fullwidth">
              <select
                value={IdPatologia}
                onChange={(e) => setIdPatologia(parseInt(e.target.value, 10))}
                required
              >
                <option value="">Seleccionar</option>
                {Patologias.map((p) => (
                  <option key={p.IdPatologia} value={p.IdPatologia}>
                    {p.Nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field">
            <label className="label required">Diagnosticos</label>
            <div className="select is-fullwidth">
              <select
                value={IdDiagnostico}
                onChange={(e) => setIdDiagnostico(parseInt(e.target.value, 10))}
                required
              >
                <option value="">Seleccionar</option>
                {Diagnosticos.map((a) => (
                  <option key={a.IdDiagnostico} value={a.IdDiagnostico}>
                    {a.Nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field mt-3">
            <button type="submit" className="button is-success">
              Guardar
            </button>
          </div>

          <div style={{ display: "flex", gap: "10px", marginBottom: "1rem" }}>
            {["todas", "activas", "inactivas"].map((estado) => (
              <button
                key={estado}
                onClick={() => setFiltroEstado(estado)}
                type="button"
                style={{
                  padding: "6px 16px",
                  border: "none",
                  borderRadius: "20px",
                  backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
                  color: filtroEstado === estado ? "#075e54" : "#333",
                  fontWeight: filtroEstado === estado ? "bold" : "normal",
                  boxShadow: filtroEstado === estado ? "inset 0 0 0 1px #1ebea5" : "inset 0 0 0 1px #ccc",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  fontSize: "0.9rem",
                }}
              >
                {estado.charAt(0).toUpperCase() + estado.slice(1)}
              </button>
            ))}
          </div>

          <div className="mt-4">
            <DataTable
              pagination
              paginationComponentOptions={paginationOptionsES}
              columns={columnas}
              data={filtrarPorEstado()}
            />
          </div>
        </form>

        {editandoRelacion && (
          <EditModal
            fields={editFields}
            initialValues={editandoRelacion}
            onSubmit={handleEditar}
            onClose={() => setEditandoRelacion(null)}
            title="Editar Diagnostico por Patologia"
          />
        )}
      </div>
    </div>
  );
};

export default AddDiagnosticoPorPatologia;
